import { NgModule, AfterContentInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

declare let $: any;

@Directive({
    selector: '[search-form-appender]',
    standalone: false
})
export class TestSearchDirective implements AfterContentInit, OnDestroy {
    listenClick: Function;

    constructor(private el: ElementRef,
                private renderer: Renderer2) {
    }

    ngAfterContentInit(): void {
        const $wrapper = $(this.el.nativeElement);

        setTimeout(() => {

            this.listenClick = this.renderer.listen($wrapper[0], 'click', this.onClick);
        });
    }

    ngOnDestroy() {
        if(this.listenClick instanceof Function) {
            this.listenClick();
        }
    }

    get selfSelectorName() {
        return this.el.nativeElement.tagName;
    }

    onClick({target}) {
        const $wrapper = $(target).closest('*[search-form-appender]');
        // const searchComp = $wrapper.siblings('#search-form-appender');
        const searchComp = $wrapper.siblings('#collapseSearchForm');
        // const parentComp = $wrapper.data('parent') || "";
        const parentCompAttr = 'main-header-navbar-mobile-top';
        const $top = $wrapper.closest(parentCompAttr);

        $top.append(searchComp);
    }

}

@NgModule({
    declarations: [TestSearchDirective],
    exports: [TestSearchDirective]
})
export class TestSearchDirectiveModule {}
